import { useState, useEffect } from 'react';
import { TimeSource } from '../types';

// Custom hook that provides current time, updating every 100ms
export function useTime(timeSource: TimeSource): Date {
  const [currentTime, setCurrentTime] = useState<Date>(timeSource.getCurrentTime());

  useEffect(() => {
    // Update time every 100ms for smooth second hand
    const interval = setInterval(() => {
      setCurrentTime(timeSource.getCurrentTime());
    }, 100);

    return () => clearInterval(interval);
  }, [timeSource]);

  return currentTime;
}

